import { Loadable, Model, ModelAttributes, model, modelConfig, reference } from "@mixitone/oom";
import TournamentSession from "./TournamentSession";
import { setAccountId } from "./concerns/SetAccountId";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    club_id: {
      type: "string",
    },
    configuration: {
      type: "json",
      jsonType: {} as any,
    },
    created_at: {
      type: "datetime",
    },
    description: {
      type: "string",
    },
    instructions: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    is_enabled: {
      type: "boolean",
    },
    payment_type: {
      type: "string",
    },
    tournament_session_id: {
      type: "string",
    },
    updated_at: {
      type: "datetime",
    },
  },
  {
    // Add collections here if needed
  },
  {
    tournamentSession: reference<any>(() => TournamentSession, "tournament_session_id"),
  },
);

interface TournamentPaymentMethod extends ModelAttributes<typeof config> {
  tournamentSession: Loadable<TournamentSession>;
}

@setAccountId
@model("tournament_payment_methods", config)
class TournamentPaymentMethod extends Model<typeof config> {}

export default TournamentPaymentMethod;
